import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "ic-label",
	templateUrl: "./label.component.html",
	styleUrls: ["./label.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InputLabelComponent {
	@Input() help: string;
	@Input() missingText: string;
	@Input() missing = false;
	@Input() required = true;
	@Input() id: string;
	@Input() pointer = false;
}
